import { isRejectedWithValue } from "@reduxjs/toolkit";
import { authApi } from "../services/auth";

export const error401Middleware = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    // if (
    //   action.payload.status === 401 &&
    //   action.meta.arg.endpointName !== "logout"
    // ) {
    //   api.dispatch(authApi.endpoints.refreshToken.initiate());
    // }
    if (
      action.payload.status === 403 &&
      (action.payload.data.message === "Session expired" ||
        action.payload.data.message === "Invalid token signature" ||
        action.payload.data.message === "Token verification failed")
    ) {
      window.location.href = "/login";
    }
    if (
      action.meta.arg.endpointName === "logout" &&
      action.payload.status === 401
    ) {
      window.location.href = "/login";
    }
  }

  return next(action);
};
